import { render, staticRenderFns } from "./DocumentListView.vue?vue&type=template&id=0f58af6e&scoped=true&"
import script from "./DocumentListView.vue?vue&type=script&lang=ts&"
export * from "./DocumentListView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f58af6e",
  null
  
)

export default component.exports